import { useMutation } from '@tanstack/react-query';

import { adjustPoints } from '~/services/LuxLoyaltyService';

import type { PointsAdjustmentRequestBody, PointsAdjustmentResponse } from '~/types/loyaltyContract';

interface UseAdjustPointsOptions {
  onSuccess?: (data: PointsAdjustmentResponse) => void;
  onError?: (error: Error) => void;
}

export function useAdjustPoints(options: UseAdjustPointsOptions = {}) {
  return useMutation({
    mutationFn: async (params: PointsAdjustmentRequestBody) => {
      return await adjustPoints(params);
    },
    onSuccess: options.onSuccess,
    onError: options.onError,
  });
}
